import axios from 'axios';
import {API} from '../../api/api';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {parseJwt_Expired} from '../../helper/parseJwtExpired';

export const changePasswordAction = createAsyncThunk(
    'changePasswordAction',
    async function (params, {rejectWithValue}) {
        const access_token_toxometris = localStorage.getItem('access_token_toxometris');
        access_token_toxometris && parseJwt_Expired(access_token_toxometris);
        try {
            const response = await axios.post(`${API.BASE_URL}/change_password`,
                JSON.stringify(params), {
                    withCredentials: true,
                    headers: {
                        'Accept': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${access_token_toxometris}`,
                        'Access-Control-Allow-Methods': 'GET,HEAD,OPTIONS,POST,PUT',
                    }
                });
            const {data, status} = response;
            if (status === 200 && data.status === 'success') {
                return response.data
            } else {
                return rejectWithValue(response.data);
            }
        } catch (error) {
            return rejectWithValue('Something is wrong, please try later.');
        }
    }
);
const changePasswordSlice = createSlice({

    name: 'CHANGE_PASSWORD_TOOLKIT',

    initialState: {
        loading: null,
        message: '',
        error: null,
        status: null
    },
    reducers: {
        logoutAction() {
            localStorage.removeItem('access_token_toxometris');
        },
        emptyData(state) {
            state.result = [];
            state.token = null;
            state.errorValidate = null;
        }
    },

    extraReducers: {
        [changePasswordAction.pending]: (state) => {
            state.status = 'CHANGE_PASSWORD_REQUEST';
            state.error = null;
            state.loading = true;
        },

        [changePasswordAction.fulfilled]: (state, action) => {
            state.status = 'CHANGE_PASSWORD_SUCCESS';
            state.message = action.payload;
            state.loading = false;
            state.error = null;
        },

        [changePasswordAction.rejected]: (state, action) => {
            state.status = 'CHANGE_PASSWORD_FAIL';
            state.loading = false;
            state.message = action.payload;
            state.error = action.payload || {message: 'ERROR !!!'};
        },
    }
});

export default changePasswordSlice.reducer;
export const {logoutAction, emptyData} = changePasswordSlice.actions;